import React, { FC, useState } from 'react';
import { IReviewNew, IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import { Box, Divider, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ReviewWrapper from '../ReviewWrapper';
import ReviewHeader from '../ReviewHeader';
import ReviewContent from '../ReviewContent';
import ReviewFooter from '../ReviewFooter';
import { LocationOn, Person } from '@mui/icons-material';
import Block from '../../Block/Block';
import { CommunityManagement } from '../../../shared/interfaces/ICommunityManagement';
import ReviewText from '../ReviewText';

interface Props extends IReviewNewProps {}

const JamedaReview: FC<Props> = ({
  commentingModule,
  communityManagement,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [showAllBlocks, setShowAllBlocks] = useState(false);

  const {
    username,
    age,
    insurance,
    location,
    title,
    text,
    rating,
    medicalPractitioner,
    mandatoryAssessments,
    optionalAssessments,
    companyComment,
  } = reviewEntry.review;

  return (
    <ReviewWrapper
      communityManagement={communityManagement}
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      rating={rating}
      reviewFor={medicalPractitioner}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      {age && age !== 'nicht angegeben' && (
        <Box sx={{ display: 'flex', alignItems: 'center', color: theme.palette.text.secondary }}>
          <Person fontSize="small" />
          <Typography
            variant="caption"
            sx={{
              ml: theme.spacing(1),
            }}
          >
            {age} {insurance && insurance !== 'nicht angegeben' && `(${insurance})`}
          </Typography>
        </Box>
      )}
      {location && (
        <Box sx={{ display: 'flex', alignItems: 'center', color: theme.palette.text.secondary }}>
          <LocationOn fontSize="small" />
          <Typography
            variant="caption"
            sx={{
              ml: theme.spacing(1),
            }}
          >
            {location}
          </Typography>
        </Box>
      )}
      {title && (
        <Typography
          variant="h6"
          sx={{
            mt: theme.spacing(2),
          }}
        >
          {title}
        </Typography>
      )}
      <ReviewText text={text} />
      {mandatoryAssessments && mandatoryAssessments.length > 0 && (
        <Box sx={{ mt: theme.spacing(2) }}>
          {showAllBlocks
            ? mandatoryAssessments.map(({ rating, original_rating, title }, index) => (
                <Box
                  key={`Review_${reviewEntry.id}_assessment_${index}`}
                  sx={{ mt: theme.spacing(1) }}
                >
                  <Divider orientation="horizontal" />
                  <Block
                    rating={rating}
                    original_rating={original_rating}
                    title={title}
                  />
                </Box>
              ))
            : mandatoryAssessments.map(({ rating, original_rating, title }, index) => (
                <Box
                  key={`Review_${reviewEntry.id}_assessment_${index}`}
                  sx={{ mt: theme.spacing(1) }}
                >
                  <Divider orientation="horizontal" />
                  <Block
                    rating={rating}
                    original_rating={original_rating}
                    title={title}
                  />
                </Box>
              ))}
        </Box>
      )}
      {optionalAssessments && optionalAssessments.length > 0 && showAllBlocks && (
        <Box sx={{ mt: theme.spacing(2) }}>
          <Typography
            variant="h6"
            sx={{ mb: theme.spacing(1) }}
          >
            Optionale Noten
          </Typography>
          {optionalAssessments.map(({ rating, original_rating, title }, index) => {
            return (
              <Box
                key={`Review_${reviewEntry.id}_OptAssessment_${index}`}
                sx={{ mt: theme.spacing(1) }}
              >
                <Divider orientation="horizontal" />
                <Block
                  rating={rating}
                  original_rating={original_rating}
                  title={title}
                />
              </Box>
            );
          })}
        </Box>
      )}
    </ReviewWrapper>
  );
};

export default JamedaReview;
